module.exports = __webpack_public_path__ + "img/favIconPois.1b0e2a38.svg";